module.exports = __webpack_public_path__ + "assets/media/drift-laptop-with-face.1ada5af5.png";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/VideoInstallStep/drift-laptop-with-face.png
// module id = 3084
// module chunks = 0